import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c430a3e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modify-se"
}
const _hoisted_2 = { class: "modify-se__section section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section__title" }, "Текущие данные урока:", -1))
const _hoisted_4 = { class: "modify-se__section section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section__title" }, "Новые данные урока:", -1))
const _hoisted_6 = { class: "modified-data__field field" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "modified-data__field field" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "modify-se__submit" }

import timerIcon from '@/assets/icons/emojis/time.png';
import schoolIcon from '@/assets/icons/emojis/school.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import bellIcon from '@/assets/icons/emojis/bell.png';
import handIcon from '@/assets/icons/emojis/hand.png';
import getModifyScheduleElementPage from '@/http/services/TeacherServices/ModifyScheduleElementPage/ModifyScheduleElementPageService';
import router from '@/router';
import { onMounted, reactive } from 'vue';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import ListSelect from '@/common/components/snedson-material-components/list-select/list-select.vue';
import TextField from '@/common/components/snedson-material-components/text-field/text-field.vue';
import { ModifySePageStateModel } from '@/http/pageModels/teacherModels/modifyScheduleElementPage/ModifySePageStateModel';
import customButton from '@/common/components/snedson-material-components/custom-button/custom-button.vue';
import patchModifyingSeService from '@/http/services/TeacherServices/ModifyScheduleElementPage/ModifyingSeService';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModifyScheduleElementPage',
  setup(__props) {

const state = reactive<{
    data: ModifySePageStateModel;
}>({
    data: {} as ModifySePageStateModel,
});

onMounted(() => {
    const mspVersion = localStorage.getItem('mspVersion');
    const mseGuid = router.currentRoute.value.params.mseId;
    const mseVersion = router.currentRoute.value.query.version;

    getModifyScheduleElementPage(
        {
            mseGuid: mseGuid as string,
            mspVersion: mspVersion ? mspVersion : 'null',
            thisMseVersion: mseVersion as string,
        },
        state
    );
});

const onLocationSelection = (locationId: number | null) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    state.data.modifiedState.locationId = locationId!;
};

const saveChanges = () => {
    if (
        state.data.modifiedState.comments ===
            state.data.originalState.actualMse.comments &&
        state.data.modifiedState.locationId ===
            state.data.originalState.actualMse.locationId
    ) {
        alert('Вы не изменили данные. ');
        return;
    }

    const returnTo = router.currentRoute.value.query.returnTo;
    patchModifyingSeService(
        {
            locationId: state.data.modifiedState.locationId,
            comment: state.data.modifiedState.comments as string,
            mseGuid: state.data.originalState.actualMse.mseUuid,
            mseVersion: state.data.originalState.actualMse.thisMseVersion,
        },
        returnTo?.toString() as string | null
    );
};

return (_ctx: any,_cache: any) => {
  return (state.data.modifiedState)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(UniversalCard, {
            class: _normalizeClass(state.data.originalState.actualMse.colorSchemeName),
            props: {
            type: 'elevated',
            title: `${state.data.originalState.actualMse.num}. ${state.data.originalState.actualMse.schoolClass.className}`,
            content: state.data.originalState.actualMse.comments as string | undefined,
            dataTags: [
                {
                    iconCompleteUrl:
                    _unref(getBaseUrl)() +
                        state.data.originalState.actualMse.iconURL,
                    color: 'var(--snotra--sys--surface-variant)',
                    title: state.data.originalState.actualMse.subjectFullName,
                },
                {
                    iconCompleteUrl: _unref(timerIcon),
                    color: 'var(--snotra--sys--surface-variant)',
                    title: `${
                        state.data.originalState.todayScheduleParams
                            .todayScheduleParams[
                            state.data.originalState.actualMse.num - 1
                        ].begin
                    } - ${
                        state.data.originalState.todayScheduleParams
                            .todayScheduleParams[
                            state.data.originalState.actualMse.num - 1
                        ].end
                    } (${
                        state.data.originalState.todayScheduleParams
                            .todayScheduleParams[
                            state.data.originalState.actualMse.num - 1
                        ].durationInMins
                    } мин.)`,
                },
                {
                    iconCompleteUrl: _unref(schoolIcon),
                    color: 'var(--snotra--sys--surface-variant)',
                    title: state.data.originalState.actualMse.location,
                },
                {
                    iconCompleteUrl: _unref(studentIcon),
                    color: 'var(--snotra--sys--surface-variant)',
                    title: state.data.originalState.actualMse.groupName
                        ? state.data.originalState.actualMse.groupName
                        : 'Весь класс ',
                },
                {
                    iconCompleteUrl: _unref(bellIcon),
                    color: 'var(--snotra--sys--surface-variant)',
                    title: `Перемена после: ${
                        state.data.originalState.todayScheduleParams
                            .todayScheduleParams[
                            state.data.originalState.actualMse.num - 1
                        ].breakDurationInMins
                    } мин.`,
                },
            ],
        }
          }, null, 8, ["class", "props"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: _normalizeClass([
                    'modified-data',
                    state.data.originalState.actualMse.colorSchemeName,
                    'material-card_type_elevated',
                ])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: _unref(schoolIcon),
                class: "field__icon"
              }, null, 8, _hoisted_7),
              _createVNode(ListSelect, {
                props: {
                            title: 'Место проведения урока',
                            isDefaultSelectionAvaliable: false,
                            menuItems: Object.entries(
                                state.data.originalState.locationsList
                            ).map(([id, title]) => ({ id: Number(id), title })),
                            selectedItemId: state.data.modifiedState.locationId,
                        },
                onSelected: onLocationSelection
              }, null, 8, ["props"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", {
                src: _unref(handIcon),
                class: "field__icon"
              }, null, 8, _hoisted_9),
              _createVNode(TextField, {
                class: "field__input",
                placeholder: 'Комментарий для учащихся',
                modelValue: state.data.modifiedState.comments,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.data.modifiedState.comments) = $event))
              }, null, 8, ["modelValue"])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(customButton, {
            props: {
                    iconName: 'check',
                    innerText: 'Сохранить изменения',
                    size: 'full',
                    type: 'filled',
                },
            onClick: saveChanges
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})